// account
export const SET_ACCOUNT = 'setAccount';
export const SET_SESSION_TOKEN = 'setToken';

// users
export const SET_USER = 'setUser';
export const SET_USERS = 'setUsers';

// organization
export const SET_ORGANIZATION = 'setOrganization';
export const SET_ORGANIZATIONS = 'setOrganizations';

// donation
export const SET_DONATION = 'setDonation';
export const SET_DONATIONS = 'setDonations';

// folder
export const SET_FOLDER = 'setFolder';
export const SET_FOLDERS = 'setFolders';

// announcement
export const SET_ANNOUNCEMENT = 'setAnnouncement';
export const SET_ANNOUNCEMENTS = 'setAnnouncements';

// shiurei torah
export const SET_SHIUREI_TORAH = 'setShiureiTorah';
export const SET_SHIUREI_TORAHS = 'setShiureiTorahs';

// template
export const SET_TEMPLATE = 'setTemplate';
export const SET_TEMPLATES = 'setTemplates';

// shiurei torah template
export const SET_SHIUREI_TORAH_TEMPLATE = 'setShiureiTorahTemplate';
export const SET_SHIUREI_TORAH_TEMPLATES = 'setShiureiTorahTemplates';

// screen
export const SET_SCREEN = 'setScreen';
export const SET_SCREENS = 'setScreens';
export const SET_SCREEN_UNAVAILABLE = 'setScreenUnavailable';

// screen_artboard
export const SET_SCREEN_ARTBOARD = 'setScreenArtboard';
export const SET_SCREEN_ARTBOARDS = 'setScreenArtboards';
export const SET_SCREEN_ARTBOARD_CONTENT = 'setScreenArtboardContent';

// member
export const SET_MEMBER = 'setMember';
export const SET_MEMBERS = 'setMembers';

// minyanim
export const SET_MINYANIM = 'setMinyanim';
export const SET_MINYANIMS = 'setMinyanims';

// minyanim_type
export const SET_MINYANIM_TYPE = 'setMinyanimType';
export const SET_MINYANIM_TYPES = 'setMinyanimTypes';

// minyanim_countdown
export const SET_MINYANIM_COUNTDOWN = 'setMinyanimCountdown';
export const SET_MINYANIM_COUNTDOWNS = 'setMinyanimCountdowns';

// room
export const SET_ROOM = 'setRoom';
export const SET_ROOMS = 'setRooms';

// zmanim
export const SET_ZMANIM = 'setZmanim';
export const SET_ZMANIMS = 'setZmanims';

// event
export const SET_EVENT = 'setEvent';
export const SET_EVENTS = 'setEvents';

// ticket
export const SET_TICKET = 'setTicket';
export const SET_TICKETS = 'setTickets';
export const SET_TICKET_UNREAD = 'setTicketUnread';
export const SET_TICKET_IN_LIST = 'setTicketInList';

// ticket_comment
export const SET_TICKET_COMMENT = 'setTicketComment';
export const SET_TICKET_COMMENTS = 'setTicketComments';
export const SET_TICKET_IN_THREAD = 'setTicketInThread';

// date_time_banner
export const SET_DATE_TIME_BANNER = 'setDateTimeBanner';
export const SET_DATE_TIME_BANNERS = 'setDateTimeBanners';

// poster
export const SET_POSTER = 'setPoster';
export const SET_POSTERS = 'setPosters';

// api_token
export const SET_API_KEY = 'setapiKey';
export const SET_API_KEYS = 'setapiKeys';

// minyan_roll_N
export const SET_MINYAN_ROLL_N = 'setMinyanRoll_N';
export const SET_MINYAN_ROLLS_N = 'setMinyanRolls_N';

// zmanim_N
export const SET_ZMANIM_N = 'setZmanim_N';
export const SET_ZMANIMS_N = 'setZmanims_N';

// zmanim_display_override_N
export const SET_ZMANIM_DISPLAY_OVERRIDE_N = 'setZmanimDisplayOverride_N';
export const SET_ZMANIM_DISPLAY_OVERRIDES_N = 'setZmanimDisplayOverrides_N';

// minyan_N
export const SET_MINYAN_N = 'setMinyan_N';
export const SET_MINYANS_N = 'setMinyans_N';

// custom_font
export const SET_CUSTOM_FONT = 'setCustomFont';
export const SET_CUSTOM_FONTS = 'setCustomFonts';

// stats
export const SET_DASHBOARD_STATS = 'setDashboardStats';

// kabbalah_N
export const SET_KABBALAH_N = 'setKabbalah_N';
export const SET_KABBALAHS_N = 'setKabbalahs_N';
export const SET_KABBALAH_N_STATS = 'setKabbalahStats_N';

// kabbalah_design_N
export const SET_KABBALAH_DESIGN_N = 'setKabbalahDesign_N';

// sidenav
export const SET_SIDENAV = 'setSidenav';

// router_loader
export const SET_ROUTER_LOADER = 'setRouterLoader';

// error
export const SET_ERRORMSG = 'setErrorMsg';
